export default {
  managerUrl: process.env.REACT_APP_ALLFLEET_MANAGER_URL,
};
